import { useEffect } from "react";
import { useLocation } from "react-router-dom"

export default function ScrollToTop ({ asmrMainRef, warEleRef, marrEleRef }) {
    const { search } = useLocation();

    useEffect(() => {
        if (search.indexOf("war") > -1) {
            warEleRef.current.scrollIntoView();
        } else if (search.indexOf("marriage") > -1) {
            marrEleRef.current.scrollIntoView();
        } else {
            window.scrollTo(0, 0);
        }
    });

    return null;
}